module.exports = __webpack_public_path__ + "b990ae5bc11fbe6df708020fda2f6fc4.png";